/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { CallWithAuth } from '../../../../../action/apiActions';
import { GET_LOD, GET_TASKS_LABEL } from '../../../../../action/apiPath';
import { BasicInformation, Get_All_Category, QuestionCreationScreenCancel } from '../../../../../redux/action';
import PrimaryTag from './PrimaryTag';
import SecondaryTag from './SecondaryTag';
import FreeTag from './FreeTag';
import MediumModal from '../../../../atoms/Modal/MediumModal';
import style from '../../../../../assets/styles/createQuestion.module.css';
import SelectType from '../QuestionCreation/SelectType';
import NativeButton from '../../../../atoms/Button';
// Interfaces
interface Tag {
  id: number;
  name?: string;
}

interface QuestionGroup {
  task_label: number | null;
  edit_task_label: number | null;
  idx: number;
  question_type_id: number | null;
  difficulty: number;
  category: number;
  academic_year?: string; // Changed from string | null
  primary_tag_id: number | null | Tag;
  secondary_tags: number[] | Tag[];
  free_tags: number[] | Tag[] | [];
  new_free_tags: string[] | [];
  primary_tag: Tag | null;
  secondary_tag: Tag[];
  free_tag: Tag[];
  new_free_tag: string[];
}

interface GroupedBody {
  question_group: QuestionGroup[];
  group_name: string;
  format: number;
}
interface ModalData {
  title: string;
  description: string;
  cancelButton: string;
  saveButton: string;
}

interface BasicInfoProps {
  id?: number;
  getData?: any;
  Draft?: number;
  subjectTag?: [];
}

interface RootState {
  BasicInformationReducer: {
    format: number;
    group_name: string;
    question_group?: any;
    primary_tag_id: number;
    secondary_tags: number[];
    free_tags: number[];
    academic_year: string;
    category: number;
    difficulty: any;
  };
  QuestionScreenReducer: {
    format: number;
    group_name: string;
    question_group?: any;
    primary_tag_id: number;
    secondary_tags: number[];
    free_tags: number[];
    academic_year: string;
    category: number;
    difficulty: any;
  };
  GetAllData: {
    categoryList: any[];
  };
}
interface LODData {
  id: number;
  name: string;
}

interface QuestionTypeData {
  id: number;
  category: string;
}

interface GetDataItem {
  edit_task_label: null;
  task_label: any;
  format: number;
  difficulty: number;
  academic_year: string;
  category: number;
  primary_tag: Tag;
  secondary_tags: Tag[];
  free_tags: Tag[];
  question_type_id?: { id: number };
  group_name?: string;
  grouped_questions?: any[]; // Define more specific type if possible
  question_id?: number;
}

const BasicInfo: React.FC<BasicInfoProps> = ({ id, getData, Draft, subjectTag }) => {
  // Initialization
  const dispatch = useDispatch();
  const location = useLocation();
  const receivedState = location.state as { question_id: number };
  const selector: GroupedBody | any = useSelector((state: RootState) => state.BasicInformationReducer);
  const selectorQuestion = useSelector((state: RootState) => state.QuestionScreenReducer);
  const selectedQuetionBankId = useSelector((state: any) => state.CreateQuestionReducer?.question_bank_id);
  const { categoryList } = useSelector((state: RootState) => state.GetAllData);
  const navigate = useNavigate();
  const queAuthoringTaskId = location.state?.queTaskId;
  const selectedQuestionBankId = selectedQuetionBankId ?? location.state?.selectedQueBankId;
  const editTaskId = location?.state?.task_label;
  // State initialization

  const [taskLabelInput, setTaskLabelInput] = useState('');
  const [taskLabelInputStatus, setTaskLabelInputStatus] = useState(false);
  const [taskLabelTag, setTaskLabelTag] = useState([]);
  const [format, setFormat] = useState<number>(0);
  const [academicYear, setAcademicYear] = useState<string | undefined>(undefined); // Changed from null
  const [category, setCategory] = useState<number | undefined | string>(undefined);
  const [difficulty, setDifficulty] = useState<number>(0);
  const [selectedPrimaryTag, setSelectedPrimaryTag] = useState<Tag | null>(null);
  const [multiselectedSecondaryTag, setMultiselectedSecondaryTag] = useState<Tag[]>([]);
  const [multiselectedfreeTag, setMultiselectedfreeTag] = useState<Tag[]>([]);
  const [newFreeTag, setNewFreeTag] = useState<string[]>([]);
  const [groupName, setGroupName] = useState<string>('');
  const [taskLabel, setTaskLabel] = useState<number | null>(null);
  const [editTaskLabel, setEditTaskLabel] = useState<number | null>(null);
  useEffect(() => {
    if (queAuthoringTaskId) {
      setTaskLabel(queAuthoringTaskId);
    } else if (
      editTaskId &&
      editTaskId != undefined &&
      editTaskId !== null &&
      (format === 0 || selector.format === 0)
    ) {
      setTimeout(() => {
        if (getData?.edit_task_label) {
          setEditTaskLabel(getData?.edit_task_label);
          if (getData?.task_label) {
            setTaskLabel(getData?.task_label);
          } else {
            setTaskLabel(getData?.edit_task_label);
          }
        }
      }, 0);
    } else if (getData?.edit_task_label && (format === 0 || selector.format === 0)) {
      setEditTaskLabel(getData?.edit_task_label);
      if (!getData?.task_label) {
        setTaskLabel(getData?.edit_task_label);
      }
    }
    if (getData?.task_label && (format === 0 || selector.format === 0)) {
      setTaskLabel(getData?.task_label);
    }
  }, []);

  // Body for dispatch
  const body = {
    format,
    difficulty,
    primary_tag_id: selectedPrimaryTag?.id,
    secondary_tags: multiselectedSecondaryTag?.map((item) => item?.id),
    free_tags: multiselectedfreeTag?.map((item) => item?.id),
    new_free_tags: newFreeTag,
    category,
    academic_year: academicYear,
    primary_tag: selectedPrimaryTag,
    secondary_tag: multiselectedSecondaryTag,
    free_tag: multiselectedfreeTag,
    new_free_tag: newFreeTag,
    task_label: taskLabel,
    edit_task_label: editTaskLabel,
  };
  const [saveButtonStatus, setSaveButtonStatus] = useState<boolean>(false);
  const [saveButtonStatusGrouped, setSaveButtonStatusGrouped] = useState<boolean>(false);
  const [modalMedium, setModalMedium] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [modalData] = useState<ModalData>({
    title: 'Are you sure, Do you want to cancel Question Creation?',
    description: 'Your Current Changes Will Not Be Saved And You Will Be Redirected To Question Listing ',
    cancelButton: 'Continue Editing',
    saveButton: 'Yes, Cancel',
  });
  const [question, setQuestion] = useState<number[]>([0]);
  const [questionbutton, setQuestionbutton] = useState<number>(0);
  const [lod, setLod] = useState<any[] | null>(null);
  const [questionCategory, setQuestionCategory] = useState<any[]>([]);
  const initialGroupedValue = {
    question_group: [
      {
        idx: 0,
        question_type_id: null,
        difficulty: 0,
        category: 0,
        academic_year: '',
        primary_tag_id: null,
        secondary_tags: [],
        free_tags: [],
        new_free_tags: [],
        primary_tag: null,
        secondary_tag: [],
        free_tag: [],
        new_free_tag: [],
        task_label: null,
        edit_task_label: null,
      },
    ],
    group_name: groupName,
    format: 1,
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  // on back GroupedBody from store and for initail load update  GroupedBody with Initial state
  const [groupedQuestion, setGroupedQuestion] = useState<GroupedBody>( //(initialGroupedValue)
    selector?.question_group ? selector : initialGroupedValue
  );

  const getCategoryStyle: any = () => {
    return {
      color: category || groupedQuestion?.question_group[questionbutton]?.category ? 'black' : '#808080',
      width: '100%',
      maxWidth: '100%',
    };
  };

  const getAcademicyearStyle: any = () => {
    return {
      color: academicYear || groupedQuestion?.question_group[questionbutton]?.academic_year ? 'black' : '#808080',
    };
  };
  useEffect(() => {
    //update setquetion state to populate all quetion data on back
    if (selector?.question_group && selector?.question_group?.length > 0) {
      const questionIndices = selector?.question_group?.map((_: any, index: any) => index);
      setQuestion(questionIndices);
    }
  }, [selector?.question_group]);

  useEffect(() => {
    const id = receivedState.question_id;
    let index = 0;

    if (format === 1 || selector?.format === 1) {
      if (getData?.length > 0) {
        if (getData[questionbutton]?.question_id === id) {
          index = questionbutton;
        }
      }
      if (queAuthoringTaskId) {
        const updatedBody = { ...groupedQuestion };
        updatedBody.question_group[questionbutton].task_label = Number(queAuthoringTaskId);
        setGroupedQuestion(updatedBody);
      } else if (editTaskId && editTaskId != undefined && editTaskId !== null) {
        setTimeout(() => {
          if (questionbutton === index) {
            if (getData?.length > 0 && getData[questionbutton]?.edit_task_label) {
              const updatedBody = { ...groupedQuestion };
              updatedBody.question_group[questionbutton].edit_task_label = Number(
                getData[questionbutton]?.edit_task_label
              );
              if (!getData[questionbutton]?.task_label) {
                updatedBody.question_group[questionbutton].task_label = Number(
                  getData[questionbutton]?.edit_task_label
                );
              }
              setGroupedQuestion(updatedBody);
            }
          }
        }, 0);
      } else if (getData?.length > 0 && getData[questionbutton]?.edit_task_label && questionbutton === index) {
        const updatedBody = { ...groupedQuestion };
        updatedBody.question_group[questionbutton].edit_task_label = Number(getData[questionbutton]?.edit_task_label);
        if (!getData[questionbutton]?.task_label) {
          updatedBody.question_group[questionbutton].task_label = Number(getData[questionbutton]?.edit_task_label);
        }
        setGroupedQuestion(updatedBody);
      }
    }
  }, [editTaskId, queAuthoringTaskId, questionbutton]);

  const openModalMedium = (): void => {
    setModalMedium(true);
  };

  const closeModalMedium = (): void => {
    setModalMedium(false);
  };

  const Cancel = (): void => {
    navigate('/question-bank');
    dispatch(QuestionCreationScreenCancel());
  };

  //get organization id
  const organizationId = localStorage.getItem('selectedOrgId');

  const AddTagsFromReduxData = async (): Promise<void> => {
    setSelectedPrimaryTag(selector?.primary_tag);
    setTaskLabel(selector?.task_label);
    setMultiselectedSecondaryTag(selector?.secondary_tag);
    setMultiselectedfreeTag(selector?.free_tag);
  };

  const LODFunction = async (): Promise<void> => {
    const data = await CallWithAuth('GET', GET_LOD + organizationId + '/');

    if (data.status && data?.res?.status === 200) {
      setLod(data.res.data as LODData[]);
    }
  };

  const generateYears = (): number[] => {
    const currentYear = new Date().getFullYear();
    const startYear = 2011;
    const endYear = currentYear + 5;
    const years: number[] = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  };

  const closeQuestion = (): void => {
    const updatedQuestions = question?.filter((item) => item !== questionbutton);
    const updatenewQuestion = question.slice(0, question.length - 1);
    setQuestion(updatenewQuestion);
    setGroupedQuestion((prevGroupedBody) => ({
      ...prevGroupedBody,
      question_group: prevGroupedBody.question_group.slice(0, updatedQuestions.length),
    }));

    if (questionbutton === 0) {
      setQuestionbutton(0);
    } else {
      setQuestionbutton((prevQuestionButton) => prevQuestionButton - 1);
    }
  };

  // Event Handlers
  const handleGroupName = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const updatedBody = { ...groupedQuestion };
    updatedBody.group_name = e.target.value;
    setGroupedQuestion(updatedBody);
    setGroupName(updatedBody.group_name);
  };

  const handleDifficultyLevel = (e: number): void => {
    const updatedBody = { ...groupedQuestion };
    updatedBody.question_group[questionbutton].difficulty = e;
    setGroupedQuestion(updatedBody);
  };

  const handleAcademicYear = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const updatedBody = { ...groupedQuestion };
    const value = e.target.value || ''; // Convert empty string to undefined
    updatedBody.question_group[questionbutton].academic_year = value;
    setGroupedQuestion(updatedBody);
  };

  const handleCategory = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const updatedBody = { ...groupedQuestion };
    const value = e.target.value ? Number(e.target.value) : undefined;
    updatedBody.question_group[questionbutton].category = value ?? 0; // Use 0 as a fallback
    setGroupedQuestion(updatedBody);
  };
  const handleQuestionType = (e: number): void => {
    const updatedBody = { ...groupedQuestion };
    updatedBody.question_group[questionbutton].question_type_id = e;
    setGroupedQuestion(updatedBody);
  };

  const RemovePrimaryTag = (): void => {
    if (format === 1) {
      const updatedBody = { ...groupedQuestion };
      updatedBody.question_group[questionbutton].primary_tag_id = null;
      setGroupedQuestion(updatedBody);
    } else {
      setSelectedPrimaryTag(null);
    }
  };

  const RemoveSecondaryTag = (): void => {
    if (format === 1) {
      const updatedBody = { ...groupedQuestion };
      updatedBody.question_group[questionbutton].secondary_tags = [];
      setGroupedQuestion(updatedBody);
    }
  };

  const RemovefreeTag = (): void => {
    if (format === 1) {
      const updatedBody = { ...groupedQuestion };
      updatedBody.question_group[questionbutton].new_free_tags = [];
      updatedBody.question_group[questionbutton].free_tags = [];
      setGroupedQuestion(updatedBody);
    }
  };

  const AddQuestion = (): void => {
    setQuestion((current) => [...current, question.length]);
    let newTaskLabel = null;
    if (queAuthoringTaskId) {
      newTaskLabel = queAuthoringTaskId;
    } else if (editTaskId !== undefined && editTaskId !== null) {
      setTimeout(() => {
        newTaskLabel = null;
      }, 0);
    }
    const data = {
      ...groupedQuestion,
      question_group: [
        ...groupedQuestion.question_group,
        {
          idx: groupedQuestion.question_group.length,
          question_type_id: null,
          difficulty: 0,
          category: 0,
          academic_year: '',
          primary_tag_id: null,
          secondary_tags: [],
          free_tags: [],
          new_free_tags: [],
          primary_tag: null,
          secondary_tag: [],
          free_tag: [],
          new_free_tag: [],
          task_label: newTaskLabel,
          edit_task_label: null,
        },
      ],
    };
    setGroupedQuestion(data);
  };

  // Effects
  useEffect(() => {
    if (selectedPrimaryTag !== null) {
      setSaveButtonStatus(false);
    } else {
      setSaveButtonStatus(true);
    }
  }, [selectedPrimaryTag]);

  useEffect(() => {
    if (selectedPrimaryTag !== null) {
      setSaveButtonStatusGrouped(false);
    } else {
      setSaveButtonStatusGrouped(true);
    }
  }, [selectedPrimaryTag]);

  useEffect(() => {
    if (selector?.isDataSaved) {
      AddTagsFromReduxData();
    }
  }, [selector]);

  useEffect(() => {
    LODFunction();
    !categoryList && dispatch(Get_All_Category(organizationId));
  }, []);

  useEffect(() => {
    if (selectedPrimaryTag !== null && format === 1) {
      const updatedBody = { ...groupedQuestion };
      if (updatedBody?.question_group[questionbutton]) {
        updatedBody.question_group[questionbutton].primary_tag_id = selectedPrimaryTag;
        updatedBody.question_group[questionbutton].primary_tag = selectedPrimaryTag;
      }
      setGroupedQuestion(updatedBody);
    }
  }, [selectedPrimaryTag]);

  useEffect(() => {
    if (multiselectedSecondaryTag?.length > 0 && format === 1) {
      const updatedBody = { ...groupedQuestion };
      updatedBody.question_group[questionbutton].secondary_tags = multiselectedSecondaryTag;
      updatedBody.question_group[questionbutton].secondary_tag = multiselectedSecondaryTag;
      setGroupedQuestion(updatedBody);
    }
  }, [multiselectedSecondaryTag]);

  useEffect(() => {
    if (newFreeTag !== null && format === 1) {
      const updatedBody = { ...groupedQuestion };
      updatedBody.question_group[questionbutton].new_free_tags = newFreeTag;
      updatedBody.question_group[questionbutton].new_free_tag = newFreeTag;
      setGroupedQuestion(updatedBody);
    }
  }, [newFreeTag]);

  useEffect(() => {
    if (multiselectedfreeTag?.length > 0 && format === 1) {
      const updatedBody = { ...groupedQuestion };
      updatedBody.question_group[questionbutton].free_tags = multiselectedfreeTag;
      updatedBody.question_group[questionbutton].free_tag = multiselectedfreeTag;
      setGroupedQuestion(updatedBody);
    }
  }, [multiselectedfreeTag]);

  const processGetData = (data: GetDataItem | GetDataItem[]): void => {
    if (!Array.isArray(data)) {
      // Single question data
      setFormat(data.format ?? 0);
      setDifficulty(data.difficulty);
      setAcademicYear(data.academic_year);
      setCategory(data?.category?.toString());
      setSelectedPrimaryTag(data.primary_tag);
      setMultiselectedSecondaryTag(data.secondary_tags);
      setMultiselectedfreeTag(data.free_tags);
      setTaskLabel(data?.task_label);
    } else {
      // Grouped questions data
      setFormat(data[0]?.format ?? 0);
      const id = receivedState.question_id;
      const index = data.findIndex((question) => question.question_id === id);
      const questionIndices = data.map((_, index) => index);
      setQuestion(questionIndices);
      setQuestionbutton(index);

      const transformedData = data.map((item, index) => ({
        idx: index,
        question_type_id: item?.question_type_id?.id ?? null,
        difficulty: item?.difficulty,
        category: item?.category,
        academic_year: item?.academic_year,
        primary_tag_id: item?.primary_tag,
        secondary_tags: item?.secondary_tags,
        free_tags: item?.free_tags,
        new_free_tags: [],
        primary_tag: item?.primary_tag,
        secondary_tag: item?.secondary_tags,
        free_tag: item?.free_tags,
        new_free_tag: [],
        task_label: item?.task_label ?? null,
        edit_task_label: item?.edit_task_label ?? null,
      }));

      setGroupName(data[0]?.group_name ?? '');
      if (transformedData?.length === 0) {
        setGroupedQuestion((prevState) => ({
          ...prevState,
          group_name: data[0]?.group_name ?? '',
          format: 1,
        }));
        setQuestion([0]);
        setQuestionbutton(0);
      } else {
        setGroupedQuestion((prevState) => ({
          ...prevState,
          question_group: transformedData,
          group_name: data[0]?.group_name ?? '',
          format: 1,
        }));
      }
    }
  };

  useEffect(() => {
    if (getData) {
      if (Draft === 0) {
        if ((getData as GetDataItem).format === 0 || Array.isArray(getData)) {
          processGetData(getData);
        }
      } else {
        // Handle draft data
        const draftData = Array.isArray(getData) ? getData[0] : getData;
        if (draftData.format === 0) {
          processGetData(draftData);
        } else if (draftData.grouped_questions) {
          processGetData(draftData.grouped_questions);
        }
      }
    }
  }, [getData]);
  // Only re-run when selector or selectorQuestion changes
  useEffect(() => {
    const populateFormData = () => {
      if (!selector?.isDataSaved || !selectorQuestion) return;
      // Handle format first
      if (selector.format !== undefined && selector?.isDataSaved) {
        setFormat(selector.format);
      }
      // For single question format
      if (selector.format === 0 && selector?.isDataSaved) {
        setDifficulty(selector.difficulty);
        setCategory(selector.category);
        setAcademicYear(selector.academic_year);
        // Populate tags
        // Primary Tag
        setSelectedPrimaryTag(selector.primary_tag);
        // Secondary Tags
        setMultiselectedSecondaryTag(selector.secondary_tag);
        // Free Tags
        setMultiselectedfreeTag(selector.free_tag);
        setTaskLabel(selector?.task_label);
        setEditTaskLabel(selector?.edit_task_label ?? null);
        //new tags
        //setNewFreeTag(selector?.new_free_tag)
      }
      // For grouped questions format
      if (selector.format === 1 && questionbutton >= 0) {
        // Initialize groupedQuestion with selector data
        const initialGroupedBody: any = {
          format: selector.format,
          group_name: selector.group_name || '',
          question_group:
            selector.question_group?.map(
              (
                group: {
                  difficulty: any;
                  category: any;
                  academic_year: any;
                  primary_tag_id: any;
                  primary_tag: any;
                  secondary_tags: any;
                  secondary_tag: any;
                  free_tags: any;
                  free_tag: any;
                  new_free_tags: any;
                  new_free_tag: any;
                  question_type_id: any;
                  task_label: any;
                  edit_task_label: any;
                },
                index: any
              ) => ({
                idx: index,
                difficulty: group.difficulty,
                category: group.category,
                academic_year: group.academic_year,
                primary_tag_id: group.primary_tag,
                secondary_tags: group.secondary_tag ?? [],
                free_tags: group.free_tag ?? [],
                new_free_tags: group.new_free_tag ?? [],
                question_type_id: group.question_type_id ?? null,
                task_label: group.task_label ?? null,
                edit_task_label: group.edit_task_label ?? null,
              })
            ) || [],
        };
        setGroupedQuestion(initialGroupedBody);
        const newData = questionbutton;
        setQuestionbutton(newData);
        setGroupName(initialGroupedBody.group_name);
        const currentGroup = initialGroupedBody.question_group[questionbutton];
        if (currentGroup) {
          handleDifficultyLevel(currentGroup.difficulty);
          setCategory(currentGroup.category);
          setAcademicYear(currentGroup.academic_year);
          // Primary Tag
          setSelectedPrimaryTag(currentGroup.primary_tag_id);
          // Secondary Tags
          setMultiselectedSecondaryTag(currentGroup?.secondary_tags);
          // Free Tags
          setMultiselectedfreeTag(currentGroup.free_tags);
        }
      }
    };
    if (selector?.isDataSaved) {
      populateFormData();
    }
  }, [selector, selectorQuestion, questionbutton]);

  useEffect(() => {
    if (selector?.isDataSaved) {
      setFormat(selector.format);
      setDifficulty(selector.difficulty);
      setCategory(selector.category);
      setAcademicYear(selector.academic_year);
      setGroupName(selector.group_name);
    }
  }, [selector, selectorQuestion]);

  const handleRemoveTaskLabel = () => {
    setTaskLabel(null);
    setTaskLabelTag([]);
    if (format === 1 || selector?.format === 1) {
      const updatedBody = { ...groupedQuestion };
      updatedBody.question_group[questionbutton].task_label = null;
      setGroupedQuestion(updatedBody);
    }
  };

  const taskLabelLists = async (e: any) => {
    setTaskLabelInput(e);
    if (e.length > 0) {
      const data = await CallWithAuth(
        'GET',
        `${GET_TASKS_LABEL}${organizationId}/?task_type=1&task_id=${e}&question_bank_id=${selectedQuestionBankId}`
      );
      if (data.status && data?.res?.status === 200) {
        if (data.res.data.length > 0) {
          setTaskLabelTag(data.res.data);
          setTaskLabelInputStatus(true);
        } else {
          setTaskLabelInputStatus(false);
        }
      }
    } else {
      setTaskLabelInputStatus(false);
    }
  };

  const selectTaskLabelTag = (e: any) => {
    setTaskLabelInputStatus(false);
    setTaskLabel(e.id);
    if (format === 1 || selector?.format === 1) {
      const updatedBody = { ...groupedQuestion };
      updatedBody.question_group[questionbutton].task_label = e.id;
      setGroupedQuestion(updatedBody);
    }
    setTaskLabelInput('');
  };
  const handleFormatChange = () => {
    if (queAuthoringTaskId) {
      const updatedBody = { ...groupedQuestion };
      updatedBody.question_group[questionbutton].task_label = Number(queAuthoringTaskId);
      setGroupedQuestion(updatedBody);
    }
  };
  return (
    <>
      <div className={`${style.select_question} ${style.basicInfo_selectquestion}`}>
        <div className={style.top_bar}>
          <div className={style.top_bar_title}>
            <span>Add Basic Information</span>
          </div>
          <div></div>
        </div>
        <div className={`${style.info} ${style.formatSelectInfo}`}>
          {/* Format Selection */}
          <div className={`${style.format} ${style.selectFormatWrap}`}>
            <div className={style.format_title}>
              Choose Format <b className={style.red_mendantory}>*</b>
            </div>
            <div className={style.format_choice}>
              <div>
                <input
                  type="radio"
                  className={style.pointer}
                  checked={format === 0}
                  id="single_question"
                  name="choose_question"
                  value="single"
                  onChange={() => {
                    setFormat(0);
                    if (!queAuthoringTaskId) {
                      setTaskLabel(null);
                    }
                  }}
                  disabled={getData && Draft === 0}
                />
                <label htmlFor="single_question">Single Question</label>
              </div>
              <div>
                <input
                  type="radio"
                  className={style.pointer}
                  checked={format === 1}
                  id="grouped_question"
                  name="choose_question"
                  value="grouped"
                  onChange={() => {
                    setFormat(1);
                    if (!queAuthoringTaskId) {
                      setTaskLabel(null);
                    }
                    handleFormatChange();
                  }}
                  disabled={getData && Draft === 0}
                />
                <label htmlFor="grouped_question">Grouped Question</label>
              </div>
            </div>
          </div>

          {/* Single Question Format */}
          {format === 0 && (
            <>
              {/* Difficulty Level */}
              <div className={style.format}>
                <div className={style.format_title}>
                  Level of Difficulty <b className={style.red_mendantory}>*</b>
                </div>
                <div className={style.format_choice}>
                  {lod?.map((item, i) => (
                    <div key={item.id + '' + item.level}>
                      <input
                        type="radio"
                        className={style.pointer}
                        checked={difficulty === item.id}
                        id={`difficulty_${item.id}`}
                        name="choose_difficulty"
                        value={item.id}
                        onChange={() => setDifficulty(item.id)}
                      />
                      <label htmlFor={`difficulty_${item.id}`}>{item.level}</label>
                    </div>
                  ))}
                </div>
              </div>

              {/* Category Selection */}
              <div className={`${style.bound} ${style.Categorybound}`}>
                <div className={style.templateDrop}>
                  <div className={style.templateDrop_item}>
                    <div className={`${style.templateGroup} ${style.categoryList}`}>
                      <span>Category </span>
                      <b className={style.red_mendantory}>*</b>
                      <select
                        name="category"
                        id="category"
                        value={category ?? ''}
                        className={style.template_drop_filter}
                        style={getCategoryStyle()}
                        onChange={(e) => setCategory(e.target.value ? Number(e.target.value) : undefined)}
                      >
                        <option value="" style={{ color: '#272727' }}>
                          Select Category
                        </option>
                        {Array.isArray(categoryList) &&
                          categoryList?.map((item) => (
                            <option
                              key={item.id + '' + item?.name}
                              value={item?.id}
                              title={item?.name?.length > 40 ? item?.name : ''}
                              style={{
                                color: 'black',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                lineHeight: '1.2',
                              }}
                            >
                              {item?.name?.length > 40 ? item?.name.slice(0, 40) + '...' : item?.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Academic Year Selection */}
                <div style={{ marginBottom: '0px' }} className={`${style.bound} `}>
                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Academic Year </span>
                        <b className={style.red_mendantory}>*</b>
                        <select
                          name="academic_year"
                          id="academic_year"
                          value={academicYear ?? ''}
                          className={style.template_drop_filter}
                          style={getAcademicyearStyle()}
                          onChange={(e) => setAcademicYear(e.target.value || undefined)}
                        >
                          <option value="" style={{ color: '#272727' }}>
                            Select Academic Year
                          </option>
                          {generateYears().map((year, i) => (
                            <option key={year + '' + i} value={year} style={{ color: 'black' }}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tags Section */}
              <div className={style.tagWrap}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {Draft === 0 ? (
                    <>
                      <PrimaryTag
                        selectedPrimaryTag={selectedPrimaryTag}
                        RemovePrimaryTag={RemovePrimaryTag}
                        setSelectedPrimaryTag={setSelectedPrimaryTag}
                        primary_id={getData?.primary_tag?.id ?? selector?.primary_tag_id}
                        questionbutton={questionbutton}
                        subjectTags={subjectTag}
                      />
                      <SecondaryTag
                        multiselectedSecondaryTag={multiselectedSecondaryTag}
                        RemoveSecondaryTag={RemoveSecondaryTag}
                        setmultiSelectedSecondaryTag={setMultiselectedSecondaryTag}
                        secondary_id={
                          getData?.secondary_tags?.map((item: { id: any }) => item.id) ?? selector?.secondary_tags
                        }
                        questionbutton={questionbutton}
                        subjectTags={subjectTag}
                      />
                      <div className={style.templateDrop}>
                        <div className={style.templateDrop_item} style={{ marginBottom: '30px' }}>
                          <div className={style.templateGroup} style={{ width: '100%' }}>
                            <p className={style.taskLabelTitle}>Add Task Label - Choose from Assigned Tasks </p>
                            <div className={style.input_search}>
                              <div className={`${style.search_listing} ${style.search_listing_tasklabel}`}>
                                <div className={style.tag_icon_tasklabel}>
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                                      stroke="#212529"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M18.2598 19.2592L16.1406 16.8594"
                                      stroke="#212529"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                  <span>Label</span>
                                </div>
                                {taskLabel || editTaskLabel ? (
                                  <>
                                    <div className={`${style.input_search} ${style.input_search_tasklabel}`}>
                                      <div style={{ fontWeight: 'normal' }}>
                                        {editTaskLabel && getData?.edit_task_label ? editTaskLabel : taskLabel}
                                      </div>
                                    </div>
                                    {!queAuthoringTaskId && !getData?.task_label && !editTaskId && (
                                      <div className={`${style.cancel_button} ${style.cancel_button_assignee}`}>
                                        <button className={style.pointer} onClick={handleRemoveTaskLabel}>
                                          <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M7.75781 7.75781L16.2431 16.2431"
                                              stroke="#272727"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                            <path
                                              d="M7.75691 16.2431L16.2422 7.75781"
                                              stroke="#272727"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </button>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <div className={`${style.input_search}`}>
                                    <input
                                      className={`${style.input_search} ${style.paddingInput} ${style.input_search_tasklabel}`}
                                      type="number"
                                      placeholder="Choose task label"
                                      value={taskLabelInput}
                                      onChange={(e) => taskLabelLists(e.target.value)}
                                      autoComplete="off"
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === 'ArrowUp' ||
                                          e.key === 'ArrowDown' ||
                                          e.key === 'e' ||
                                          e.key === 'E' ||
                                          e.key === '+' ||
                                          e.key === '-' ||
                                          e.key === '.'
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onWheel={(e) => (e.target as HTMLInputElement).blur()}
                                    />
                                    {taskLabelInputStatus ? (
                                      <div
                                        className={`${style.list_input_primary} ${style.input_primary_dropdown}`}
                                        style={{ width: '95%', maxHeight: '20vh', overflow: 'auto' }}
                                      >
                                        {taskLabelTag?.map((items: any, i: any) => (
                                          <NativeButton
                                            key={items?.id + '' + i}
                                            onClick={() => selectTaskLabelTag(items)}
                                          >
                                            <div className={style.optionTaskLabel}>
                                              <span>{items?.id} </span>
                                            </div>
                                          </NativeButton>
                                        ))}
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <FreeTag
                        multiselectedfreeTag={multiselectedfreeTag}
                        RemovefreeTag={RemovefreeTag}
                        setmultiSelectedfreeTag={setMultiselectedfreeTag}
                        setnewFreeTag={setNewFreeTag}
                        newFreeTag={newFreeTag}
                        free_id={getData?.free_tags?.map((item: { id: any }) => item.id) ?? selector?.free_tags}
                        questionbutton={questionbutton}
                      />
                    </>
                  ) : (
                    <>
                      <PrimaryTag
                        selectedPrimaryTag={selectedPrimaryTag}
                        RemovePrimaryTag={RemovePrimaryTag}
                        setSelectedPrimaryTag={setSelectedPrimaryTag}
                        primary_id={getData[0]?.primary_tag?.id ?? selector?.primary_tag_id}
                        questionbutton={questionbutton}
                        subjectTags={subjectTag}
                      />
                      <SecondaryTag
                        multiselectedSecondaryTag={multiselectedSecondaryTag}
                        RemoveSecondaryTag={RemoveSecondaryTag}
                        setmultiSelectedSecondaryTag={setMultiselectedSecondaryTag}
                        secondary_id={
                          getData[0]?.secondary_tags?.map((item: { id: any }) => item.id) ?? selector?.secondary_tags
                        }
                        questionbutton={questionbutton}
                        subjectTags={subjectTag}
                      />
                      <div className={style.templateDrop}>
                        <div className={style.templateDrop_item} style={{ marginBottom: '30px' }}>
                          <div className={style.templateGroup} style={{ width: '100%' }}>
                            <p className={style.taskLabelTitle}>Add Task Label - Choose from Assigned Tasks </p>
                            <div className={style.input_search}>
                              <div className={`${style.search_listing} ${style.search_listing_tasklabel}`}>
                                <div className={style.tag_icon_tasklabel}>
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                                      stroke="#212529"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M18.2598 19.2592L16.1406 16.8594"
                                      stroke="#212529"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                  <span>Label</span>
                                </div>
                                {taskLabel || editTaskLabel ? (
                                  <>
                                    <div className={`${style.input_search} ${style.input_search_tasklabel}`}>
                                      <div style={{ fontWeight: 'normal' }}>
                                        {editTaskLabel && getData?.edit_task_label ? editTaskLabel : taskLabel}
                                      </div>
                                    </div>
                                    {!queAuthoringTaskId && !getData?.task_label && !editTaskId && (
                                      <div className={`${style.cancel_button} ${style.cancel_button_assignee}`}>
                                        <button className={style.pointer} onClick={handleRemoveTaskLabel}>
                                          <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M7.75781 7.75781L16.2431 16.2431"
                                              stroke="#272727"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                            <path
                                              d="M7.75691 16.2431L16.2422 7.75781"
                                              stroke="#272727"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </button>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <div className={`${style.input_search}`}>
                                    <input
                                      className={`${style.input_search} ${style.paddingInput} ${style.input_search_tasklabel}`}
                                      type="number"
                                      placeholder="Choose task label"
                                      value={taskLabelInput}
                                      onChange={(e) => taskLabelLists(e.target.value)}
                                      autoComplete="off"
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === 'ArrowUp' ||
                                          e.key === 'ArrowDown' ||
                                          e.key === 'e' ||
                                          e.key === 'E' ||
                                          e.key === '+' ||
                                          e.key === '-' ||
                                          e.key === '.'
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onWheel={(e) => (e.target as HTMLInputElement).blur()}
                                    />
                                    {taskLabelInputStatus ? (
                                      <div
                                        className={style.list_input_primary}
                                        style={{ width: '95%', maxHeight: '20vh', overflow: 'auto' }}
                                      >
                                        {taskLabelTag?.map((items: any, i: any) => (
                                          <NativeButton
                                            key={items?.id + '' + i}
                                            onClick={() => selectTaskLabelTag(items)}
                                          >
                                            <div className={style.optionTaskLabel}>
                                              <span>{items?.id} </span>
                                            </div>
                                          </NativeButton>
                                        ))}
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <FreeTag
                        multiselectedfreeTag={multiselectedfreeTag}
                        RemovefreeTag={RemovefreeTag}
                        setmultiSelectedfreeTag={setMultiselectedfreeTag}
                        setnewFreeTag={setNewFreeTag}
                        newFreeTag={newFreeTag}
                        free_id={getData[0]?.free_tags?.map((item: { id: any }) => item.id) ?? selector?.free_tags}
                        questionbutton={questionbutton}
                      />
                    </>
                  )}
                </div>
              </div>

              {/* Save Button Section */}
              <div className={style.saveButton_questionBank}>
                <button
                  className={`${style.cancel} ${style.pointer} ${style.cancelBtnWrap} `}
                  onClick={openModalMedium}
                >
                  Cancel
                </button>
                <div>
                  <button
                    className={saveButtonStatus ? style.blue_button_disable : style.blue_button}
                    disabled={saveButtonStatus}
                    onClick={() => dispatch(BasicInformation(body, id, 0))}
                  >
                    Save & Continue
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
        {/*  ___________ code for single question ___________ */}

        {/*  ___________ code for group question ___________ */}

        {format === 1 && (
          <>
            {groupedQuestion?.question_group
              ?.filter((item) => item.idx === questionbutton)
              ?.map((items, index) => (
                <>
                  <div className={style.bound}>
                    <div className={style.templateDrop}>
                      <div className={style.templateDrop_item}>
                        <div className={style.templateGroup}>
                          <span>Group Name </span>
                          <input
                            value={groupName ?? groupedQuestion.group_name}
                            onChange={handleGroupName}
                            placeholder="Enter Group Name"
                            className={style.textInput}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr style={{ border: '2px solid #ECF3F5' }} />
                  <div
                    className={style.container}
                    style={{ width: '100%', overflowX: question?.length >= 5 ? 'scroll' : 'hidden' }}
                  >
                    {question?.map((items, i) => (
                      <button
                        key={items + '' + i}
                        draggable="true"
                        className={
                          items === questionbutton
                            ? ` ${style.multiquestionbutton} ${style.draggable}`
                            : ` ${style.multiquestionbuttonBlue} ${style.draggable}`
                        }
                        onClick={() => setQuestionbutton(i)}
                      >
                        {items === questionbutton ? (
                          <svg
                            width="10"
                            height="14"
                            viewBox="0 0 10 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                              fill="white"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="10"
                            height="14"
                            viewBox="0 0 10 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                              fill="#272727"
                            />
                          </svg>
                        )}{' '}
                        <span style={{ width: '115px' }}>&nbsp; Question {i + 1}</span>
                      </button>
                    ))}
                  </div>

                  {/* Add question button: to add more answer  */}
                  <div style={{ display: 'flex', marginTop: '10px', justifyContent: 'space-between', height: '50' }}>
                    <button
                      className={` ${style.Add_answer} ${style.pointer} ${style.AddbuttonWrap}`}
                      style={{ marginTop: '0px' }}
                      onClick={() => AddQuestion()}
                      onKeyDown={(e) => {
                        e.key === 'Enter' && AddQuestion();
                      }}
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                          stroke="#00ABFB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7.5 12H16.5"
                          stroke="#00ABFB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 16.5V7.5"
                          stroke="#00ABFB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span>Add Questions to the Group</span>
                    </button>

                    {/* Current QUESTION RUNNING  */}
                    <div className={style.questions_remove}>
                      {question?.length > 1 ? (
                        <div className={style.remove} style={{ width: '100%' }}>
                          <button
                            className={` ${style.remove_question} ${style.pointer}`}
                            onClick={() => closeQuestion()}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                stroke="#272727"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                stroke="#272727"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                stroke="#272727"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            &nbsp;
                            <span>Remove This Question</span>
                          </button>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  <div className={style.academicCategoryWrap}>
                    <div className={`${style.info} ${style.lodInfo}`}>
                      <div className={style.format}>
                        <div className={style.format_title}>
                          Level of Difficulty <b className={style.red_mendantory}>*</b>
                        </div>
                        <div className={style.format_choice}>
                          {lod?.map((items, i) => (
                            <div key={items.level + '' + i}>
                              <input
                                type="radio"
                                className={style.pointer}
                                checked={groupedQuestion.question_group[questionbutton].difficulty === items.id}
                                id="difficulty"
                                name="choose_difficulty"
                                value="difficulty"
                                onClick={() => handleDifficultyLevel(items.id)}
                              />
                              <label htmlFor="html">{items.level}</label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className={`${style.bound} ${style.boundWrap}`}>
                      <div className={style.templateDrop}>
                        <div className={style.templateDrop_item}>
                          <div className={style.templateGroup}>
                            <span>Category </span>
                            <b className={style.red_mendantory}>*</b>
                            <select
                              name="question"
                              id="question"
                              style={getCategoryStyle()}
                              className={style.template_drop_filter}
                              onChange={(e) => handleCategory(e)}
                              value={items.category ?? 'Select Category'}
                            >
                              <option value={''} style={{ color: '#272727' }}>
                                Select Category
                              </option>
                              {Array.isArray(categoryList) &&
                                categoryList?.map((item, i) => (
                                  <option
                                    key={item?.id + '' + i}
                                    value={item?.id}
                                    title={item.name?.length > 38 ? item.name : ''}
                                    style={{
                                      color: 'black',
                                      whiteSpace: 'normal',
                                      overflowWrap: 'break-word',
                                    }}
                                  >
                                    {item?.name?.length > 38 ? item.name.slice(0, 38) + '...' : item.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className={style.templateDrop}>
                        <div className={style.templateDrop_item}>
                          <div className={style.templateGroup}>
                            <span>Academic Year </span>
                            <b className={style.red_mendantory}>*</b>
                            <select
                              name="question"
                              id="question"
                              className={style.template_drop_filter}
                              style={getAcademicyearStyle()}
                              onChange={(e) => handleAcademicYear(e)}
                              value={items.academic_year === null ? 'Select Academic Year' : items.academic_year}
                            >
                              <option value={''} style={{ color: '#272727' }}>
                                Select Academic Year
                              </option>
                              {generateYears().map((year, i) => (
                                <option key={year + '' + i} value={year} style={{ color: 'black' }}>
                                  {year}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <PrimaryTag
                    questionbutton={questionbutton}
                    RemovePrimaryTag={RemovePrimaryTag}
                    selectedPrimaryTag={selectedPrimaryTag}
                    setSelectedPrimaryTag={setSelectedPrimaryTag}
                    primary_id={groupedQuestion.question_group[questionbutton].primary_tag_id}
                    subjectTags={subjectTag}
                  />
                  <SecondaryTag
                    questionbutton={questionbutton}
                    RemoveSecondaryTag={RemoveSecondaryTag}
                    multiselectedSecondaryTag={multiselectedSecondaryTag}
                    setmultiSelectedSecondaryTag={setMultiselectedSecondaryTag}
                    secondary_id={groupedQuestion.question_group[questionbutton].secondary_tags}
                    subjectTags={subjectTag}
                  />
                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item} style={{ marginBottom: '30px' }}>
                      <div className={style.templateGroup} style={{ width: '100%', maxWidth: '510px' }}>
                        <p className={style.taskLabelTitle}>Add Task Label - Choose from Assigned Tasks </p>
                        <div className={style.input_search}>
                          <div className={`${style.search_listing} ${style.search_listing_tasklabel}`}>
                            <div className={style.tag_icon_tasklabel}>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                                  stroke="#212529"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M18.2598 19.2592L16.1406 16.8594"
                                  stroke="#212529"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              <span>Label</span>
                            </div>
                            {items?.task_label || items?.edit_task_label ? (
                              <>
                                <div className={`${style.input_search} ${style.input_search_tasklabel}`}>
                                  <div style={{ fontWeight: 'normal' }}>
                                    {items?.edit_task_label && getData[questionbutton]?.edit_task_label
                                      ? items?.edit_task_label
                                      : items?.task_label}
                                  </div>
                                </div>
                                {!queAuthoringTaskId &&
                                  !(getData?.length > 0 && getData[questionbutton]?.task_label) &&
                                  !editTaskId && (
                                    <div className={`${style.cancel_button} ${style.cancel_button_assignee}`}>
                                      <button className={style.pointer} onClick={handleRemoveTaskLabel}>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M7.75781 7.75781L16.2431 16.2431"
                                            stroke="#272727"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M7.75691 16.2431L16.2422 7.75781"
                                            stroke="#272727"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </button>
                                    </div>
                                  )}
                              </>
                            ) : (
                              <div className={`${style.input_search}`}>
                                <input
                                  className={`${style.input_search} ${style.paddingInput} ${style.input_search_tasklabel}`}
                                  type="number"
                                  placeholder="Choose task label"
                                  value={taskLabelInput}
                                  onChange={(e) => taskLabelLists(e.target.value)}
                                  autoComplete="off"
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === 'ArrowUp' ||
                                      e.key === 'ArrowDown' ||
                                      e.key === 'e' ||
                                      e.key === 'E' ||
                                      e.key === '+' ||
                                      e.key === '-' ||
                                      e.key === '.'
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onWheel={(e) => (e.target as HTMLInputElement).blur()}
                                  disabled={getData?.length > 0 && getData[questionbutton] !== questionbutton}
                                />
                                {taskLabelInputStatus ? (
                                  <div
                                    className={style.list_input_primary}
                                    style={{ width: '95%', maxHeight: '20vh', overflow: 'auto' }}
                                  >
                                    {taskLabelTag?.map((items: any, i: any) => (
                                      <NativeButton key={items?.id + '' + i} onClick={() => selectTaskLabelTag(items)}>
                                        <div className={style.optionTaskLabel}>
                                          <span>{items?.id} </span>
                                        </div>
                                      </NativeButton>
                                    ))}
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <FreeTag
                    questionbutton={questionbutton}
                    RemovefreeTag={RemovefreeTag}
                    multiselectedfreeTag={multiselectedfreeTag}
                    setmultiSelectedfreeTag={setMultiselectedfreeTag}
                    setnewFreeTag={setNewFreeTag}
                    newFreeTag={newFreeTag}
                    free_id={groupedQuestion.question_group[questionbutton].free_tags}
                  />

                  {questionCategory
                    ?.filter((item) => item.id === groupedQuestion.question_group[questionbutton].question_type_id)
                    ?.map((items, i) => (
                      <div
                        key={items.name + '' + i}
                        className={style.question_creating}
                        style={{ height: '5%', marginBottom: '30px' }}
                      >
                        <div>
                          <div className={style.question_creating_title}>
                            <span>{items.name}</span>
                          </div>
                        </div>
                      </div>
                    ))}

                  <SelectType
                    setQuestionCategories={setQuestionCategory}
                    id={id}
                    index={index}
                    selectedID={groupedQuestion.question_group[questionbutton].question_type_id}
                    data={selectorQuestion}
                    format={format}
                    questiontype={
                      questionbutton >= 0 && getData ? getData[questionbutton]?.question_type_id : undefined
                    }
                    handleQuestionType={handleQuestionType}
                    getData={getData}
                  />
                </>
              ))}

            <div className={style.saveButton_questionBank} style={{ marginTop: '30px' }}>
              <button
                className={` ${style.cancel} ${style.pointer} ${style.cancelBtnWrap}`}
                onClick={() => openModalMedium()}
              >
                Cancel
              </button>
              <div>
                <button
                  className={saveButtonStatusGrouped ? `${style.blue_button_disable}` : `${style.blue_button}`}
                  onClick={() => dispatch(BasicInformation(groupedQuestion, id, 1))}
                >
                  Save & Continue
                </button>
              </div>
            </div>
          </>
        )}

        {/*  ___________ code for group question ___________ */}
      </div>
      {modalMedium && (
        <MediumModal
          modalMedium={modalMedium}
          forwardButton={() => Cancel()}
          closeModalMedium={closeModalMedium}
          modalData={modalData}
        />
      )}
    </>
  );
};

export default BasicInfo;
